const pro = {
  path: 'https://api.pinkuaikuai.cn',
  wssPath: 'wss://api.pinkuaikuai.cn'
}
export default pro
